import { ColDef } from '@ag-grid-community/core';
import dayjs from 'dayjs';

import { TableConstants } from '@shared/constants/table.constants';
import { Utils } from '@shared/utils/utils';

import { InvestigatorForecastGridRow } from '../types/investigator-forecast-grid-row';
import { InvestigatorForecastTableContext } from '../types/investigator-forecast-table-context';

const YEAR_LENGTH = 4;

export const getInvestigatorForecastPeriodColumnDefs = (
  ctx: InvestigatorForecastTableContext
): ColDef<InvestigatorForecastGridRow>[] => {
  return ctx.periods.map((period) => {
    const isOpenMonth = dayjs(period).isSame(ctx.currentOpenMonth, 'month');
    const formattedPeriod =
      period.length === YEAR_LENGTH ? period : dayjs(period).format('MMM YYYY');
    const headerName = isOpenMonth ? `${formattedPeriod} (Open)` : formattedPeriod;

    return {
      aggFunc: 'sum',
      cellClass: [
        TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT,
        'text-right',
        `budgetCost${ctx.currency}`,
      ],
      field: period,
      headerName,
      maxWidth: 200,
      minWidth: 120,
      resizable: true,
      valueFormatter: (params) => Utils.agCurrencyFormatter(params, ctx.currency),
    };
  });
};
